<template>
	<script v-if="shouldShow" type="application/ld+json">
		{{ json }}
	</script>
</template>

<script>
import router from 'router';
import { htmlToText, inStockAnywhere } from 'utils';

export default {
	props: {
		product: {
			type: Object,
			required: true,
		},
		/**
		 * Top reviews.
		 */
		reviews: {
			type: Array,
			default: () => [],
		},
		nrReviews: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		shouldShow () {
			// Google requires either a rating, a review or an offer.
			// If none of the above are specified, this is considered an error.
			return this.rating || this.reviews.length || this.showPrice;
		},
		organizationId () {
			return this.baseUrl + '/#organization';
		},
		inStock () {
			const stock = this.product.stock;
			if (stock) {
				for (const s in stock) {
					if (! isNaN(s) && stock[s] > 0) {
						return true;
					}
				}
			}
			return false;
		},
		isReleased () {
			if (! this.product.release) {
				return true; // @TODO dubbelkolla
			}
			const date = new Date();
			date.setTime(this.product.release.timestamp * 1000);
			const now = new Date();
			return now >= date;
		},
		itemAvailability () {
			if (! this.isReleased) {
				return 'PreOrder';
			}
			if (this.inStock) {
				return 'InStock';
			}
			if (this.product.discontinued) {
				return 'Discontinued';
			}
			return 'OutOfStock';
		},
		baseUrl () {
			return router.getBaseUrl();
		},
		mpn () {
			if (this.product.partNumbers.length) {
				return this.product.partNumbers[0];
			}
			return '';
		},
		brand () {
			if (this.product.manufacturer) {
				return this.product.manufacturer.name;
			}
			return '';
		},
		rating () {
			if (this.product.averageRating) {
				const rating = this.product.averageRating;
				if (rating.rating) {
					return rating.rating;
				}
				return rating;
			}
			return null;
		},
		showPrice () {
			return this.product.price && this.product.price.price != this.product.regularPrice.price && (! this.product.discontinued ||
				(this.product.discontinued && inStockAnywhere(this.product.stock)));
		},
		json () {
			const json =  {
				'@context': 'http://schema.org/',
				'@type': 'Product',
				sku: this.product.id,
				name: this.product.name,
				image: this.baseUrl + this.product.images[0].large,
				description: htmlToText(this.product.description),
				mpn: this.mpn,
				brand: {
					'@type': 'Thing',
					name: this.brand,
				},
			};

			json.offers = {
				'@type': 'Offer',
				priceCurrency: this.product.price ? this.product.price.currency : null,
				price: this.product.price ? this.product.price.price : null,
				availability: 'http://schema.org/' + this.itemAvailability,
				seller: {
					'@type': 'Organization',
					id: this.organizationId,
					name: 'Webhallen',
				},
				url: this.baseUrl + this.$route.path,
			};

			if (this.product.price && this.product.price.endAt) {
				json.offers.priceValidUntil = this.product.price.endAt;
			}

			if (this.rating) {
				json.aggregateRating = {
					'@type': 'AggregateRating',
					ratingValue: this.rating,
					reviewCount: this.nrReviews || '',
				};
			}

			if (this.reviews.length) {
				const review = this.reviews[0];
				json.review = {
					'@type': 'Review',
					author: review.isAnonymous ? 'No-Face' : review.user.username,
					reviewBody: review.text,
					reviewRating: {
						'@type': 'Rating',
						bestRating: 5,
						ratingValue: review.rating,
						worstRating: 1,
					},
				};
			}

			return JSON.stringify(json);
			// Fråga Dobby.
			// return JSON.stringify(json).replace(/</g,'\\u003c').replace(/>/g,'\\u003e');
		},
	},
};
</script>

